module.exports = __webpack_public_path__ + "static/img/section-member.000a3ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/course-detail/section-member.png
// module id = TJrS
// module chunks = 1